'use strict';
const angular = require('angular');

export function DomainCollectionInstanceProvider() {
  return {
    $get: [
      function () {
        function DomainCollectionInstance(instance, collectionInstance) {
          Object.defineProperties(this, {
            $$parent: {value: instance},
            $$collection: {value: collectionInstance}
          })
        }

        DomainCollectionInstance.prototype.getFirstItem = getFirstItem;
        DomainCollectionInstance.prototype.getFirstRelation = getFirstRelation;
        DomainCollectionInstance.prototype.getItems = getItems;
        DomainCollectionInstance.prototype.getSubLinkItems = getSubLinkItems;
        DomainCollectionInstance.prototype.getRelations = getRelations;
        DomainCollectionInstance.prototype.getSubLinkRelations = getSubLinkRelations;
        DomainCollectionInstance.prototype.getRelation = getRelation;
        DomainCollectionInstance.prototype.getAllRelations = getAllRelations;
        DomainCollectionInstance.prototype.addItem = addItem;
        DomainCollectionInstance.prototype.removeItem = removeItem;

        function getFirstItem() {
          return this.$$collection.getFirstItem(this.$$parent.$id);
        }

        function getFirstRelation() {
          return this.$$collection.getFirstRelation(this.$$parent.$id);
        }

        function getItems() {
          return this.$$collection.getItems(this.$$parent.$id);
        }

        function getSubLinkItems(sublinkId) {
          return this.$$collection.getSubLinkItems(this.$$parent.$id, sublinkId);
        }

        function getAllItems() {
          return this.$$collection.getAllItems(this.$$parent.$id);
        }

        function getRelations() {
          return this.$$collection.getRelations(this.$$parent.$id);
        }

        function getSubLinkRelations(sublinkId) {
          return this.$$collection.getSubLinkRelations(this.$$parent.$id, sublinkId);
        }

        function getRelation(linkId) {
          return this.$$collection.getRelation(this.$$parent.$id, linkId);
        }

        function getRelationRef(linkId) {
          return this.$$collection.getRelationRef(this.$$parent.$id, linkId);
        }

        function getAllRelations() {
          return this.$$collection.getAllRelations(this.$$parent.$id);
        }

        function addItem(foreignId, value) {
          return this.$$collection.addItem(this.$$parent.$id, foreignId, value);
        }

        function removeItem(foreignId) {
          return this.$$collection.removeItem(this.$$parent.$id, foreignId);
        }


        return DomainCollectionInstance;
      }]
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/DomainCollectionInstance.js